<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        28.10.2018
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Podiumsgast beim Berlinale Film Gewinner <q>Touch me not</q></h3>
      <div class="mb-1 text-body-secondary">28.10.2018</div>
      <p>
        Der Film Touch me not gewann 2018 den Goldenen Bären auf der Berlinale.
        <a href="https://www.dampfzentrale.ch/event/tib-2018-adina-pintilie-rou-touch-me-not/"  target="_blank">
          Vorpremiere
        </a>
         in Bern. Es freut mich als Geschäftsführerin zur anschliessenden Podiumsdiskussion geladen zu sein
        Teilnehmer*innen:
      </p>
      <ul>
        <li>
          <span class="fw-bold">Michael Turinsky</span> Choreograf, Performer und Theoretiker
        </li>
        <li>
          <span class="fw-bold">Petra Wohlwend</span> Sexualberaterin
        </li>
        <li>
          <span class="fw-bold">Isabelle Kölbl</span> Sexualbegleiterin
        </li>
      </ul>
    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/images/blog/blog6_1.png" alt="sexcare bild" width="250">
    </div>
  </div>
</div>
